import { useMemo } from "react";
import {
  addDays,
  addMonths,
  differenceInDays,
  endOfMonth,
  endOfWeek,
  format,
  getDate,
  getDay,
  isAfter,
  isSameMonth,
  max,
  min,
  startOfMonth,
  subDays
} from "../../../../date-fns/index.js";
import { useCalendarConfiguration } from "../CalendarRoot.js";
import { parseDate } from "../utils.js";
function useComputeMonthsData() {
  const config = useCalendarConfiguration();
  const { minDate, maxDate, monthsCount, referenceDate, dateFnsOptions, monthLabelFormat, includeAdjacentMonthDays } = config;
  return useMemo(() => {
    return computeMonthsData({
      minDate,
      maxDate,
      monthsCount,
      referenceDate,
      dateFnsOptions,
      monthLabelFormat,
      includeAdjacentMonthDays
    });
  }, [referenceDate, includeAdjacentMonthDays, dateFnsOptions, monthsCount, minDate, maxDate, monthLabelFormat]);
}
function computeMonthsData(inputData) {
  const {
    referenceDate,
    includeAdjacentMonthDays,
    dateFnsOptions,
    monthsCount,
    minDate: rawMinDate,
    maxDate: rawMaxDate,
    monthLabelFormat
  } = inputData;
  const result = [];
  let monthReferenceDate = new Date(referenceDate);
  const minDate = rawMinDate ? parseDate(rawMinDate, dateFnsOptions) : void 0;
  const maxDate = rawMaxDate ? parseDate(rawMaxDate, dateFnsOptions) : void 0;
  for (let i = 0; i < monthsCount; i++) {
    const startOfMonthDate = startOfMonth(monthReferenceDate);
    const endOfMonthDate = endOfMonth(monthReferenceDate);
    if (maxDate && isAfter(startOfMonthDate, maxDate)) {
      continue;
    }
    const firstDay = minDate && isSameMonth(minDate, startOfMonthDate) ? max([startOfMonthDate, minDate]) : startOfMonthDate;
    let daysToStartOfWeek = 0;
    while (getDay(subDays(startOfMonthDate, daysToStartOfWeek)) !== dateFnsOptions.weekStartsOn) {
      daysToStartOfWeek++;
    }
    const daysToStartOfMonth = getDate(firstDay) - 1;
    const prevOffset = daysToStartOfWeek + daysToStartOfMonth;
    const lastDay = maxDate && isSameMonth(maxDate, startOfMonthDate) ? min([endOfMonthDate, maxDate]) : endOfMonthDate;
    const nextOffset = differenceInDays(endOfWeek(lastDay, dateFnsOptions), lastDay);
    const start = includeAdjacentMonthDays && monthsCount === 1 ? subDays(firstDay, prevOffset) : firstDay;
    const end = includeAdjacentMonthDays && monthsCount === 1 ? addDays(lastDay, nextOffset) : lastDay;
    const label = format(monthReferenceDate, monthLabelFormat, dateFnsOptions);
    const id = firstDay.toISOString();
    const offset = includeAdjacentMonthDays && monthsCount === 1 ? [0, 0] : [prevOffset, nextOffset];
    monthReferenceDate = addMonths(monthReferenceDate, 1);
    result.push({
      id,
      label,
      start,
      end,
      offset
    });
  }
  return result;
}
export {
  computeMonthsData,
  useComputeMonthsData
};
//# sourceMappingURL=useComputeMonthsData.js.map
